mutation RetryAccountDeletion($accountId: ID!) {
  result: StreamToolsRetryAccountDeletion(accountId: $accountId) {
    accountId
    status
    requestedAt
    completedAt
    wasSuspended
    steps
  }
}
